import { ComponentPropsWithoutRef } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import styles from "./TextArea.module.css";
import Label from "../Label";

type TextAreaProps = ComponentPropsWithoutRef<"textarea"> & {
  label: string;
  register?: UseFormRegisterReturn;
  error?: string;
  required?: boolean;
  hasTooltip?: boolean;
  underDevelopment?: boolean;
  content?: string;
};

export default function TextArea({
  label,
  hasTooltip,
  required,
  content,
  error,
  register,
  placeholder,
  id,
  underDevelopment,
  ...props
}: TextAreaProps) {
  return (
    <div className={styles["form__input--container"]}>
      <Label
        tooltipContent={content}
        underDevelopment={underDevelopment}
        required={required}
      >
        {label}
      </Label>
      <textarea
        className={styles["textarea"]}
        id={id}
        {...props}
        {...register}
        placeholder={props.disabled ? "" : placeholder || label}
        wrap="hard"
      />
      {error && (
        <span role="alert" className={styles["form__input--error"]}>
          {error}
        </span>
      )}
    </div>
  );
}
